import React, { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import './featureRouter.css';
import { RequirePermission } from '../shared/routing/requirePermission';
import { useRouteInfo } from '../../services/routing/useRouteInfo';
import { ErrorPage } from '../shared/error/errorPage';
import { getRouteAnimationDirection } from '../../services/routing/routes';


export const FeatureRouter = () => {
    const routeInfo = useRouteInfo();
    const [displayRouteInfo, setDisplayRouteInfo] = useState(routeInfo);
    const [transitionState, setTransitionState] = useState('in');
    const [routeDirection, setRouteDirection] = useState('none');
    const [routePermissions, setRoutePermissions] = useState([]);

    useEffect(() => {
        if (routeInfo !== displayRouteInfo) {
            setRouteDirection(getRouteAnimationDirection(routeInfo, displayRouteInfo) ?? '')
            setTransitionState('out');
        }
    }, [routeInfo]);


    useEffect(() => {
        setRoutePermissions(getPermissions(displayRouteInfo))

        if (transitionState === 'out')
            setTransitionState('in');
    }, [displayRouteInfo]);

    const aniEnded = () => {
        if (transitionState === 'out') {
            setDisplayRouteInfo(routeInfo);

        } else if (transitionState === 'in') {
            setTransitionState('');
        }
    }

    const getPermissions = (route) => {
        let permissions = route.permissions ?? [];
        if (route.parent) permissions = permissions.concat(getPermissions(route.parent));
        return permissions;
    }


    return (
        <ErrorBoundary fallbackRender={() => <ErrorPage>An issue occurred and the app could not recover. Refresh the page and try again.</ErrorPage>}>
            <div className={'routes-wrapper ' + routeDirection + ' ' + transitionState}>
                <div  className='routes' onAnimationEnd={aniEnded}>
                    {displayRouteInfo.featureComponent ?
                        <RequirePermission permission={routePermissions}>
                            <displayRouteInfo.featureComponent />
                        </RequirePermission>
                        :
                        <ErrorPage>The page you are looking for isn't here.</ErrorPage>
                    }
                </div>
            </div>
        </ErrorBoundary>
    )
}